module.exports = __webpack_public_path__ + "static/media/sg12tj93.ab2d0cb1.png";